import { useState } from "react";
import LoginScreen from "./pages/Login";
import Home from "./pages/Home";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  return loggedIn ? (
    <Home />
  ) : (
    <LoginScreen onLogin={() => setLoggedIn(true)} />
  );
}

export default App;
